// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDaS0kjNLBXjg_CyFzaT-ixJZ3fInv0OlY",
    authDomain: "hiveexp-c92e4.firebaseapp.com",
    projectId: "hiveexp-c92e4",
    storageBucket: "hiveexp-c92e4.firebasestorage.app",
    messagingSenderId: "946964277346",
    appId: "1:946964277346:web:6885bb62a467d399df893b",
    measurementId: "G-E542BLNVY6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);